// extracted by mini-css-extract-plugin
export var chevron = "_l0-3";
export var chevronRotated = "_l0-4";
export var image = "_l0-1";
export var imageContainer = "_l0-0";
export var shippingAddress = "_l0-2";